// Core
import React from 'react';
import { Box, Flex, Text, Divider, Grid, Image } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import privileges1 from 'assets/img/glow-2.png';
import privileges2 from 'assets/img/glow-5.png';
import privileges3 from 'assets/img/glow.png';
import privileges4 from 'assets/img/glow-11.png';

// Components
import Card from 'components/Card/Card';

const Privileges = () => {
    return (
    	<Grid templateColumns={{ sm: '1fr', md: '1fr 1fr' }} gap="24px" rowGap={{base: '12px', md: '24px'}} templateRows='1fr'>
	        <Card padding="0px" overflow="hidden" className="animation-privileges">
	            <Box p="21px 16px" zIndex="2">
	            	<Text variant="header" fontSize="24px" fontStyle="normal">Exclusive discounts</Text>
	            	<Text mt="16px" maxW="70%">
	            		Unlock access to substantial discounts at businesses across Australia, all for a low monthly membership fee.
	            	</Text>
	            </Box>

	            <Box position="absolute" w="100%" right="0px" zIndex="1" className="animation-privileges-scale">
	            	<Image src={privileges1} alt="privileges" float="right" m="-105px -175px 0px 0" />
	            </Box>
	        </Card>

	        <Card padding="0px" overflow="hidden" className="animation-privileges">
	            <Box p="21px 16px" zIndex="2">
	            	<Text variant="header" fontSize="24px" fontStyle="normal">Flexibility to opt-out</Text>
	            	<Text mt="16px" maxW="70%">
	            		We value your freedom. Not feeling the ride anymore? Cancel your membership at any time, no strings attached.
	            	</Text>
	            </Box>

	            <Box position="absolute" w="100%" right="0px" zIndex="1" className="animation-privileges-scale">
	            	<Image src={privileges2} alt="privileges" w="363px" float="right" m="-77px -113px 0 0" transform="rotate(27deg)" />
	            	<Lines className="abstract-lines" style={{ zIndex: 1, top: '-397px', transform: 'scale(0.5)', right: '-310px', left: 'unset' }} />
	            </Box>
	        </Card>

	        <Card padding="0px" overflow="hidden" className="animation-privileges">
	            <Box p="21px 16px" zIndex="2">
	            	<Text variant="header" fontSize="24px" fontStyle="normal">Trusted partnerships</Text>
	            	<Text mt="16px" maxW="70%">
	            		We`ve partnered with reputable businesses nationwide to ensure our members receive only the best deals and offers.
	            	</Text>
	            </Box>

	            <Box position="absolute" w="100%" right="0px" zIndex="1" className="animation-privileges-scale">
	            	<Image src={privileges3} alt="privileges" float="right" m="-147px -155px 0 0" w="410px" />
	            	<Lines className="abstract-lines" style={{ zIndex: 1, top: '-397px', transform: 'scale(0.4) rotate(250deg)', right: '-270px', left: 'unset' }} />
	            </Box>
	        </Card>

	        <Card padding="0px" overflow="hidden" className="animation-privileges">
	            <Box p="21px 16px" zIndex="2">
	            	<Text variant="header" fontSize="24px" fontStyle="normal">Expert support</Text>
	            	<Text mt="16px" maxW="70%">
						Got questions or need assistance? Our professional support team is always ready to help you navigate your journey with us.
	            	</Text>
	            </Box>

	            <Box position="absolute" w="100%" right="0px" zIndex="1" className="animation-privileges-scale">
	            	<Image src={privileges4} alt="privileges" float="right" w="300px" m="-93px -94px 0px 0" />
	            	<Lines className="abstract-lines" style={{ zIndex: 1, top: '-327px', transform: 'scale(0.4) rotate(94deg)', right: '-280px', left: 'unset' }} />
	            	<Box zIndex="-1" bg="#099BFF" filter="blur(36px)" w="150px" h="150px" position="absolute" top="10px" right="10px" borderRadius="100%" />
	            </Box>
	        </Card>
	    </Grid>
    );
};


export default Privileges;